import { Box } from '@mui/material';
import React from 'react';
import ChargeTitle from '../Charges/ChargeTitle';
import SingleCharge from '../Charges/SingleCharge';
import Divider from '@Components/Divider';
import Comments from './Comment';
import { RootStateType } from '@Store';
import { useSelector } from 'react-redux';
import { formatNumber, useLocale } from '../../../../utils/formatNumber';

function PaymentCompletedDetails() {
  const shipmentpayment = useSelector((state: RootStateType) => state.adminShipment.shipmentpayment);
  const { amount, payableAmount = 0, totalPaidAmt = 0, tdsAmount = 0, _transactionsId } = shipmentpayment || {};
  const successfulTransactions = _transactionsId?.filter(payment => payment.status === 'successful') || [];

  const totalAmount = successfulTransactions.reduce((sum, t) => {
    if (t.status !== 'successful') return sum;

    if (t.type === 'refund') {
      return sum - Math.abs(t.amount) - Math.abs(t.tdsAmount || 0);
    }
    // console.info
    if (new Date(t.createdAt) < new Date('2024-12-18T10:36:19.670+00:00')) {
      const amount = t.amount;
      const amountWithTds = amount + (t.tdsAmount || 0);
      return sum + amountWithTds;
    }

    const amount = t.type === 'credit' ? t.amount : -Math.abs(t.amount);
    const amountWithTds = amount + (t.tdsAmount || 0);
    return sum + amountWithTds;
  }, 0);

  const totalTdsAmount = successfulTransactions.reduce((sum, payment) => sum + payment.tdsAmount, 0);
  const locale = useLocale();

  return (
    <Box sx={{ width: '100%' }}>
      <ChargeTitle />
      <Divider className="my-1" />
      <SingleCharge displayKey="Total Amount" value={(amount && formatNumber(amount, locale)) || 0} />
      <SingleCharge
        displayKey="Paid"
        value={
          tdsAmount == 0 && totalTdsAmount == 0 ? formatNumber(totalPaidAmt, locale) : formatNumber(totalAmount, locale)
        }
      />
      <SingleCharge displayKey="Deductions" value={formatNumber(totalTdsAmount + tdsAmount, locale)} />
      <SingleCharge
        displayKey="Amount Due"
        value={formatNumber(payableAmount === 0 ? 0 : payableAmount - tdsAmount, locale)}
      />

      <Divider className="my-1" />
      <Comments />
    </Box>
  );
}

export default PaymentCompletedDetails;
